import React from "react";
import { ApplicationsIcon } from "../../../Icons";
import { clinicalCosignerApi } from "../../../services/librariesCatalogService";
import LibraryCatalogPage, {
  cellStrong,
} from "../components/LibraryCatalogPage";
import ClinicalCosignerFormModal from "./ClinicalCosignerFormModal";

const columns = [
  {
    header: "Form Creator Role",
    accessor: "formCreatorRoleName",
    sortable: true,
    render: (row) => (
      <span className={cellStrong}>{row.formCreatorRoleName || "—"}</span>
    ),
  },
  {
    header: "Form Signer Role",
    accessor: "formSignerRoleName",
    sortable: true,
    render: (row) => (
      <span className={cellStrong}>{row.formSignerRoleName || "—"}</span>
    ),
  },
];

const ClinicalCosignersPage = () => (
  <LibraryCatalogPage
    title="Clinical Co-signers"
    icon={ApplicationsIcon}
    addLabel="Create New"
    searchPlaceholder="Search by creator or signer role..."
    entityLabel="Clinical co-signer"
    defaultSortBy="createdAt"
    api={clinicalCosignerApi}
    columns={columns}
    FormModal={ClinicalCosignerFormModal}
    getDeleteLabel={(row) =>
      `${row.formCreatorRoleName || "Creator"} → ${row.formSignerRoleName || "Signer"}`
    }
  />
);

export default ClinicalCosignersPage;
